import { AbstractControl } from '@angular/forms';
import { PeselService } from '../services/pesel.service';

export function PeselValidator(control: AbstractControl) {
  let pesel = control.value;

  if (pesel === null || pesel === undefined || pesel.length === 0) {
    // if pesel is not present, dont send error, use Validators.required
    return null;
  }

  if (pesel.length === 11) { // sprawdzamy czy ciąg ma 11 cyfr
    let birthDate = PeselService.getBirthdate(pesel);
    if (!(birthDate instanceof Date) || isNaN(birthDate.valueOf())) {
      return {validPeselBirthDate: false};
    }

    const steps = new Array(1, 3, 7, 9, 1, 3, 7, 9, 1, 3); // tablica z odpowiednimi wagami
    let calculatedCheckSum = (
      steps[0] * parseInt(pesel[0]) +
      steps[1] * parseInt(pesel[1]) +
      steps[2] * parseInt(pesel[2]) +
      steps[3] * parseInt(pesel[3]) +
      steps[4] * parseInt(pesel[4]) +
      steps[5] * parseInt(pesel[5]) +
      steps[6] * parseInt(pesel[6]) +
      steps[7] * parseInt(pesel[7]) +
      steps[8] * parseInt(pesel[8]) +
      steps[9] * parseInt(pesel[9])
    ) % 10;
    if (calculatedCheckSum === 0) {
      calculatedCheckSum = 10;
    }
    calculatedCheckSum = 10 - calculatedCheckSum; // obliczamy sumę kontrolną
    let checkSumFromPesel = parseInt(pesel[10]);
    if (calculatedCheckSum === checkSumFromPesel) { // sprawdzamy czy taka sama suma kontrolna jest w ciągu
      return true;
    } else {
      return {validPesel: false};
    }
  } else {
    return {validPeselLenght: false};
  }
}
